import React from 'react';
import {useTranslation} from 'react-i18next';
import {Text, View} from 'react-native';
import {colorPalette} from '../../../../../theme';
import styles from './Step.style';

function StepTitle(index, t) {
  switch (index) {
    case 0:
      return t('first');
    case 1:
      return t('second');
    case 2:
      return t('third');
    case 3:
      return t('third');
    default:
      return '-';
  }
}

export default function Step(props) {
  const {numberOfPoints, activeIndex, isActiveIndexPass} = props;
  const {t} = useTranslation();

  return (
    <View>
      <Text style={styles.text}>
        {t('stage')} {StepTitle(activeIndex, t)}
      </Text>
      <View style={styles.pointsWrapper}>
        {Array(numberOfPoints)
          ?.fill('')
          ?.map((_, index) => {
            return (
              <View
                style={[
                  styles.point,
                  {
                    backgroundColor:
                      activeIndex > index
                        ? colorPalette.successDarker
                        : activeIndex < index
                        ? colorPalette.grey1_5
                        : isActiveIndexPass && activeIndex === index
                        ? colorPalette.successDarker
                        : colorPalette.grey8_5,
                  },
                ]}
              />
            );
          })}
      </View>
    </View>
  );
}
